import React, { useState } from 'react';
import { Card, CardContent } from './ui/card';
import { Button } from './ui/button';
import { ChevronDown, ChevronUp, CheckCircle2 } from 'lucide-react';

export default function ToolSteps({ tool }) {
  const [isExpanded, setIsExpanded] = useState(false);
  
  if (!tool.steps || tool.steps.length === 0) return null;
  
  return (
    <div className="mt-4">
      <Button
        variant="outline"
        size="sm"
        onClick={() => setIsExpanded(!isExpanded)}
        className="w-full"
      >
        {isExpanded ? (
          <>
            <ChevronUp className="w-4 h-4 mr-2" />
            Hide Step-by-Step Guide
          </>
        ) : (
          <>
            <ChevronDown className="w-4 h-4 mr-2" />
            Show Step-by-Step Guide (Beginner-Friendly)
          </>
        )}
      </Button>
      
      {isExpanded && (
        <div className="mt-4 space-y-3 bg-muted/30 p-4 rounded-lg border">
          <p className="text-sm font-medium mb-3">
            Complete Guide for Absolute Beginners:
          </p>
          {tool.steps.map((step, index) => (
            <div key={index} className="flex gap-3">
              <div className="flex-shrink-0 w-6 h-6 rounded-full bg-primary text-primary-foreground flex items-center justify-center text-xs font-bold">
                {index + 1}
              </div>
              <div className="flex-1">
                <p className="text-sm leading-relaxed">{step}</p>
              </div>
            </div>
          ))}
          <div className="mt-4 pt-3 border-t flex items-start gap-2">
            <CheckCircle2 className="w-4 h-4 text-success mt-0.5 flex-shrink-0" />
            <p className="text-xs text-muted-foreground">
              Follow these steps in order, and you'll be using {tool.name} like a pro in no time!
            </p>
          </div>
        </div>
      )}
    </div>
  );
}
